var _a;
import VueX from "vuex";
import Vue from "vue";
import { rootState } from "../model/RootState";
import RootType from "./mutation-types";
import { homeState } from "../modules/home";
import AuthBiz from "../biz/AuthBiz";
Vue.use(VueX);
export default new VueX.Store({
    state: rootState,
    getters: {
        isErp: function (state) { return state.isErp; },
        token: function (state) { return state.token; },
        user: function (state) { return state.loginModel; },
        region: function (state) { return state.regionTree; },
        homeShow: function (state) { return state.homeShow; },
        typeDict: function (state) {
            return state.typeList.reduce(function (ori, item) {
                ori[item.type + "_" + item.value] = item;
                return ori;
            }, {});
        },
        serviceData: function (state) { return state.serviceData; },
        serviceFlag: function (state) { return state.serviceFlag; },
        serviceDataList: function (state) {
            console.log(state.serviceData);
            var data = state.serviceData.list && state.serviceData.list.find(function (item) {
                return item.service_id == 3;
            });
            if (data) {
                return data.power_key;
            }
            else {
                return [];
            }
        },
        openedCodeData: function (state) { return state.openedCodeData; },
        ediStatus: function (state) { return state.ediStatus; },
        canSelectBatch: function (state) { return state.canSelectBatch; },
        canSendEmail: function (state) { return state.canSendEmail; },
        allSettingScale: function (state) { return state.allSettingScale; },
        getBusinessConfig: function (state) { return function (business_id, name, defaultValue) {
            var config = state.allSettingScale.find(function (item) { return item.business_id === business_id; });
            if (!config) {
                return defaultValue;
            }
            if (!name) {
                return config;
            }
            if (config.other_config && name in config.other_config) {
                return config.other_config[name];
            }
            if (name in config) {
                return config[name];
            }
            return defaultValue;
        }; }
    },
    mutations: (_a = {},
        _a[RootType.UPDATE_TOKEN] = function (state, token) {
            state.token = token;
        },
        _a[RootType.UPDATE_LOGINMODEL] = function (state, model) {
            state.loginModel = model;
        },
        _a[RootType.UPDATE_MENULIST] = function (state, menuList) {
            state.menuList = menuList;
        },
        _a[RootType.UPDATE_REGIONTREE] = function (state, regionTree) {
            state.regionTree = regionTree;
        },
        _a[RootType.UPDATE_CONFIG] = function (state, config) {
            state.config = config;
        },
        _a[RootType.UPDATE_HOMESHOW] = function (state, homeShow) {
            state.homeShow = homeShow;
        },
        _a[RootType.UPDATE_MSG_TYPE] = function (state, typeList) {
            state.typeList = typeList;
        },
        _a[RootType.UPDATE_SERVICE_DATA] = function (state, serviceData) {
            state.serviceData = serviceData;
        },
        _a[RootType.UPDATE_SERVICE_FLAG] = function (state, serviceFlag) {
            state.serviceFlag = serviceFlag;
        },
        _a[RootType.UPDATE_OPENED_CODE_DATA] = function (state, openedCodeData) {
            state.openedCodeData = openedCodeData;
        },
        _a[RootType.UPDATE_EDI_STATUS] = function (state, ediStatus) {
            state.ediStatus = ediStatus;
        },
        _a[RootType.UPDATE_CAN_SELECT_BATCH] = function (state, canSelectBatch) {
            state.canSelectBatch = canSelectBatch;
        },
        _a[RootType.UPDATE_CAN_SEND_EMAIL] = function (state, canSendEmail) {
            state.canSendEmail = canSendEmail;
        },
        _a[RootType.UPDATE_IS_ERP] = function (state, isErp) {
            state.isErp = isErp;
        },
        _a[RootType.UPDATE_ALL_SETTING_SCALE] = function (state, settings) {
            state.allSettingScale = settings;
        },
        _a),
    modules: {
        home: homeState
    },
    actions: {
        updateUser: function (_a, model) {
            var commit = _a.commit;
            commit(RootType.UPDATE_LOGINMODEL, model);
        },
        updateMenuList: function (_a, menuList) {
            var commit = _a.commit;
            commit(RootType.UPDATE_MENULIST, menuList);
        },
        getAuth: function (_a, code) {
            var state = _a.state;
            return findAuth(state.menuList, code);
        },
        updateRegionTree: function (_a, regionTree) {
            var commit = _a.commit;
            commit(RootType.UPDATE_REGIONTREE, regionTree);
        },
        updateHomeShow: function (_a, homeShow) {
            var commit = _a.commit;
            commit(RootType.UPDATE_HOMESHOW, homeShow);
        },
        updateMsgType: function (_a, typeList) {
            var commit = _a.commit;
            commit(RootType.UPDATE_MSG_TYPE, typeList);
        },
        updateServiceData: function (_a, serviceData) {
            var commit = _a.commit;
            commit(RootType.UPDATE_SERVICE_DATA, serviceData);
        },
        updateServiceFlag: function (_a, serviceFlag) {
            var commit = _a.commit;
            commit(RootType.UPDATE_SERVICE_FLAG, serviceFlag);
        },
    }
});
function findAuth(menuList, code) {
    var pageAuth;
    for (var index = 0; index < menuList.length; index++) {
        var element = menuList[index];
        if (element.power_code == code) {
            pageAuth = AuthBiz.getAuth(element.power_code, element.power_key || []);
        }
        if (element.children && element.children.length) {
            pageAuth = findAuth(element.children, code);
        }
        if (pageAuth) {
            pageAuth.Response = pageAuth.Response || element;
            break;
        }
    }
    return pageAuth;
}
